"use client";

import React, { useEffect } from 'react';
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import HeroSection from '@/app/home-page/components/HeroSection';
import ServicesSection from '@/app/home-page/components/ServicesSection';
import AIAgentsSection from '@/app/home-page/components/AIAgentsSection';
import UseCasesSection from '@/app/home-page/components/UseCasesSection';
import ProcessSection from '@/app/home-page/components/ProcessSection';
import WhyDevrosSection from '@/app/home-page/components/WhyDevrosSection';
import CTASection from '@/app/home-page/components/CTASection';

export default function AIAgentsPage() {
  useEffect(() => {
    const el = document.getElementById('ai-agents');
    if (el) el?.scrollIntoView({ behavior: 'smooth' });
  }, []);

  return (
    <main className="min-h-screen bg-bg overflow-x-hidden">
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Fraunces:ital,wght@0,400;0,600;0,700;0,900;1,400;1,700&family=Manrope:wght@400;500;600;700;800&display=swap');
      `}</style>
      <Header />
      <HeroSection />
      <ServicesSection />
      <AIAgentsSection />
      <UseCasesSection />
      <ProcessSection />
      <WhyDevrosSection />
      <CTASection />
      <Footer />
    </main>
  );
}
